import { Component } from "@angular/core";

@Component({
  selector: "ch-not-found",
  templateUrl: "./not-found.component.html",
})
export class NotFoundComponent {
  constructor() {}
}
